import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService {

  private readonly header = new BehaviorSubject<boolean>(false);
  spinnerVisible$ = this.header.asObservable();

  show() {
    // Use setTimeout without delay to wait for next UI turn in order to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.header.next(true);
    });
  }
  hide() {
    // Use setTimeout without delay to wait for next UI turn in order to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.header.next(false);
    });
  }
}
